import type { ChatRole, HealthResponse, WidgetChatResponse } from "@/types";

/** Как Hugo: apiBase + apiPath (layouts/partials/ai-widget.html) */
function apiBase(): string {
  // В dev — относительные URL, Vite проксирует /health и /widget (без CORS с прода)
  if (import.meta.env.DEV) return "";
  return (import.meta.env.VITE_WIDGET_API_URL || "").replace(/\/+$/, "");
}

function widgetApiPath(): string {
  const p = (import.meta.env.VITE_WIDGET_API_PATH || "/widget/chat").trim();
  return p.startsWith("/") ? p : `/${p}`;
}

function widgetUrl(path: string): string {
  const base = apiBase();
  if (base) return `${base}${path}`;
  return path;
}

export async function checkHealth(): Promise<HealthResponse | null> {
  try {
    const res = await fetch(widgetUrl("/health"));
    if (!res.ok) return null;
    return (await res.json()) as HealthResponse;
  } catch {
    return null;
  }
}

export async function sendWidgetChat(params: {
  message: string;
  history: ChatRole[];
  sessionId: string;
}): Promise<WidgetChatResponse> {
  const ragTarget = import.meta.env.VITE_RAG_TARGET || "chz";
  const pageTitle =
    (typeof document !== "undefined" && document.title) ||
    import.meta.env.VITE_APP_TITLE ||
    "Архив чата — маркировка";

  const res = await fetch(widgetUrl(widgetApiPath()), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      rag_target: ragTarget,
      session_id: params.sessionId,
      message: params.message,
      history: params.history,
      page_url: window.location.href,
      page_title: pageTitle,
    }),
  });

  if (!res.ok) {
    let detail = "";
    try {
      const body = await res.json();
      detail =
        typeof body?.detail === "string"
          ? body.detail
          : JSON.stringify(body?.detail ?? body);
    } catch {
      detail = await res.text().catch(() => "");
    }
    throw new Error(
      detail ||
        `Ошибка API (${res.status}). Проверьте ${apiBase() || "widget API"} и rag_target=${import.meta.env.VITE_RAG_TARGET || "chz"}`
    );
  }

  return (await res.json()) as WidgetChatResponse;
}
